__turbopack_context__.v({
  "filters": "collab-listing-module__bMGNYW__filters",
  "filtersTop": "collab-listing-module__bMGNYW__filtersTop",
});
